function waitForElement(selector, timer = 10000, frequency = 25) {
    return new Promise((resolve, reject) => {
        let element = document.querySelector(selector);
        if (timer <= 0) return reject(`waitForElement | Couldn't find element with selector: ${selector}`);
        if (element) return resolve(element);
        setTimeout(() => {
            waitForElement(selector, (timer - frequency), frequency)
                .then(resolve)
                .catch(reject);
        }, frequency);
    });
}

function waitUntil(poller, timer = 10000, frequency = 25) {
    return new Promise((resolve, reject) => {
        if (timer <= 0) return reject('waitFor | Timer expired');
        const result = poller();
        if (result) return resolve(result);
        return setTimeout(() => {
            waitUntil(poller, (timer - frequency), frequency)
                .then(resolve)
                .catch(reject);
        }, frequency);
    });
}

void (function loadVariation() {
  const pdpRevamp = {
    init: function () {
      document.documentElement.classList.add(pdpRevamp.id);
      console.log(
        `%c ${pdpRevamp.name}: ${pdpRevamp.variation}: ${pdpRevamp.version}`,
        "color: black; background: white; font-size: 20px"
      );
      pdpRevamp.mainJS();
    },
    mainJS: function () {
     

      waitForElement(".desktop-feefo.site-header-account-link a").then((feefoLink) => {
        feefoLink.insertAdjacentHTML(
          "beforebegin",
          `<a href="/pages/our-reviews" class="tp-reviews">
              <strong>Excellent</strong>&nbsp;
              <img src='https://storage.googleapis.com/abtest-img-bucket/bb-18/tp-stars.png' width='86' alt='Trustpilot Stars'>
              <span><strong>4.8</strong><span> out of 5 based on 1300+ reviews</span></span>
              <img src='https://storage.googleapis.com/abtest-img-bucket/bb-18/tp-brand-logo.png' alt='Trustpilot Brand Logo' width='81'>
            </a>`
        );
      });
      waitForElement(".cw-payment-options").then((feefoLink) => {
        feefoLink.insertAdjacentHTML(
          "beforebegin",
          `<div class="tst22-block"><a href="/pages/our-reviews" class="tp-reviews">
              <strong>Excellent</strong>&nbsp;
              <img src='https://storage.googleapis.com/abtest-img-bucket/bb-18/tp-stars.png' width='86' alt='Trustpilot Stars'>
              <span><strong>4.8</strong><span> out of 5 based on 1300+ reviews</span></span>
              <img src='https://storage.googleapis.com/abtest-img-bucket/bb-18/tp-brand-logo.png' alt='Trustpilot Brand Logo' width='81'>
            </a></div>`
        );
      });

function revampProductTile(container, isRecentlyViewed = false) {
  container.querySelectorAll(".productgrid--item").forEach((tile, index) => {
    const tags = tile.querySelector(".productitem--info").dataset.tags;

    if (!isRecentlyViewed) {
      const wishlistButton = document.createElement("button");
      wishlistButton.classList.add("cw-wishlist");
      wishlistButton.innerHTML = `
        <span class="wishlist-icon">
          <svg class="empty show" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.3435 1.43359C13.9719 1.06198 13.5307 0.767241 13.0451 0.566217C12.5596 0.365194 12.0391 0.261827 11.5136 0.262024C10.988 0.262222 10.4677 0.365979 9.98228 0.567367C9.49685 0.768756 9.05588 1.06383 8.68454 1.43572L8.19982 1.92634L7.71914 1.43678L7.71601 1.43365C7.34458 1.06222 6.90362 0.767577 6.41831 0.566556C5.93301 0.365536 5.41286 0.262072 4.88757 0.262072C4.36228 0.262072 3.84214 0.365536 3.35683 0.566556C2.87153 0.767577 2.43057 1.06222 2.05914 1.43365L1.8432 1.64959C1.09306 2.39974 0.671631 3.41715 0.671631 4.47801C0.671631 5.53888 1.09306 6.55629 1.8432 7.30644L7.54235 13.0055L8.18595 13.6798L8.20129 13.6645L8.21795 13.6811L8.82095 13.0449L14.5594 7.30634C15.3085 6.5556 15.7291 5.53841 15.7291 4.47792C15.7291 3.41743 15.3085 2.40024 14.5594 1.6495L14.3435 1.43359ZM13.8522 6.59925L8.20129 12.2503L2.55026 6.59925C1.98766 6.03664 1.67159 5.27358 1.67159 4.47794C1.67159 3.68229 1.98766 2.91923 2.55026 2.35662L2.76623 2.14069C3.32856 1.57836 4.09116 1.26231 4.88642 1.26201C5.68167 1.26172 6.44451 1.57719 7.00726 2.13909L8.19767 3.35119L9.39373 2.14069C9.67231 1.86211 10.003 1.64113 10.367 1.49036C10.731 1.3396 11.1211 1.262 11.5151 1.262C11.909 1.262 12.2991 1.3396 12.6631 1.49036C13.0271 1.64113 13.3578 1.86211 13.6364 2.14069L13.8523 2.35659C14.4141 2.91966 14.7296 3.68257 14.7295 4.47795C14.7295 5.27332 14.414 6.03621 13.8522 6.59925Z" fill="black"/>
          </svg>
          <svg class="added hide" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="16" height="16" fill="white"/>
            <path d="M14.1602 2.46911C13.7885 2.0975 13.3473 1.80276 12.8618 1.60174C12.3762 1.40072 11.8558 1.29735 11.3302 1.29755C10.8047 1.29774 10.2843 1.4015 9.79893 1.60289C9.31351 1.80428 8.87253 2.09935 8.50119 2.47124L8.01647 2.96186L7.53579 2.4723L7.53266 2.46918C7.16123 2.09774 6.72027 1.8031 6.23496 1.60208C5.74966 1.40106 5.22951 1.29759 4.70422 1.29759C4.17893 1.29759 3.65879 1.40106 3.17348 1.60208C2.68818 1.8031 2.24722 2.09774 1.87579 2.46918L1.65985 2.68511C0.909707 3.43526 0.488281 4.45267 0.488281 5.51354C0.488281 6.5744 0.909707 7.59181 1.65985 8.34196L7.359 14.0411L8.0026 14.7154L8.01794 14.7L8.0346 14.7166L8.6376 14.0804L14.3761 8.34187C15.1251 7.59112 15.5458 6.57393 15.5458 5.51344C15.5458 4.45295 15.1251 3.43576 14.3761 2.68502L14.1602 2.46911ZM13.6688 7.63477L8.01794 13.2858L2.36691 7.63477C1.80431 7.07216 1.48824 6.3091 1.48824 5.51346C1.48824 4.71781 1.80431 3.95475 2.36691 3.39215L2.58288 3.17621C3.14521 2.61388 3.90781 2.29784 4.70307 2.29754C5.49832 2.29724 6.26116 2.61271 6.82391 3.17461L8.01432 4.38671L9.21038 3.17621C9.48896 2.89763 9.81967 2.67665 10.1837 2.52588C10.5476 2.37512 10.9377 2.29752 11.3317 2.29752C11.7257 2.29752 12.1158 2.37512 12.4798 2.52588C12.8437 2.67665 13.1745 2.89763 13.453 3.17621L13.669 3.39211C14.2307 3.95519 14.5462 4.71809 14.5462 5.51347C14.5462 6.30884 14.2306 7.07173 13.6688 7.63477Z" fill="#FF0E0E"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3.3374 1.22408C3.84052 0.984066 4.38775 0.859493 4.94165 0.858887C5.4944 0.858887 6.03965 0.983208 6.5459 1.22408C7.0514 1.46418 7.5059 1.81383 7.88465 2.24818C7.93928 2.31069 8.00595 2.36066 8.08035 2.39485C8.15476 2.42905 8.23525 2.44671 8.31665 2.44671C8.39805 2.44671 8.47854 2.42905 8.55295 2.39485C8.62735 2.36066 8.69402 2.31069 8.74865 2.24818C9.51515 1.37016 10.5712 0.858887 11.6917 0.858887C12.8114 0.858887 13.8682 1.36938 14.6347 2.24818C15.3989 3.12387 15.8167 4.29638 15.8167 5.50463C15.8167 6.71288 15.3989 7.88538 14.6347 8.76185L9.98615 14.0906C9.7752 14.3325 9.51762 14.5258 9.23005 14.6582C8.94248 14.7905 8.63132 14.8589 8.31665 14.8589C8.00199 14.8589 7.69082 14.7905 7.40325 14.6582C7.11568 14.5258 6.8581 14.3325 6.64715 14.0906L1.99865 8.76107C1.61736 8.32133 1.31965 7.81097 1.12115 7.25678C0.919509 6.69651 0.81638 6.10335 0.816651 5.5054C0.816651 4.90555 0.919401 4.31036 1.12115 3.75247C1.31975 3.19857 1.61746 2.68847 1.99865 2.24896C2.37304 1.81663 2.82856 1.46791 3.3374 1.22408Z" fill="#EE304C"/>
            </svg>          
        </span>
      `;

      wishlistButton.addEventListener("click", (e) => {
        const controlWishlist = tile.querySelector(".productitem--action-trigger button");
        if (controlWishlist) controlWishlist.click();

        wishlistButton.classList.add("cw-added");

        // Toggle SVGs
        wishlistButton.querySelector(".empty").classList.remove("show");
        wishlistButton.querySelector(".empty").classList.add("hide");
        wishlistButton.querySelector(".added").classList.remove("hide");
        wishlistButton.querySelector(".added").classList.add("show");
      });

      waitUntil(() =>
        tile.querySelector(".productitem--action-trigger button") &&
        tile.querySelector(".productitem--action-trigger button").classList.length > 0
      )
        .then(() => wishlistButton.classList.add("cw-added"))
        .catch((e) => true);

      waitUntil(() =>
        tile.querySelector(".productitem--action-atc[data-quick-buy]:not([disabled]) .atc-button--text")
      )
        .then((atc) => (atc.textContent = "Add to basket"))
        .catch((e) => true);

      tile.appendChild(wishlistButton);
    }

    getFormat(tile.querySelector("a.productitem--image-link").pathname, index, tags).then((format) => {
      if (!format) return;
      tile
        .querySelector(".productitem--image")
        .insertAdjacentHTML("afterend", `<div data-format="${format}" class="cw-format">${format}</div>`);
    });

    const savePercentageElem = tile.querySelector("[data-price-percent-saved]");
    const priceContainer = tile.querySelector(".productitem--price");

    if (savePercentageElem && priceContainer) {
      const savePercentage = savePercentageElem.textContent.trim();
      priceContainer.insertAdjacentHTML(
        "beforeend",
        `<div class="cw-save-percentage">You save ${savePercentage}%</div>`
      );
    }
  });
}


      function getFormat(url, index, tags) {
        return new Promise((resolve) => {
          const matchedFormat = tags.match(/format_(\w+)/gi);
          if (matchedFormat) {
            return resolve(matchedFormat[0].replace(/format_(\w+)/gi, "$1"));
          }
          const xhr = new XMLHttpRequest();
          xhr.open("GET", url + ".json", true);
          xhr.onload = function () {
            if (xhr.status !== 200) return resolve(null);
            let data;
            try {
              data = JSON.parse(xhr.responseText);
            } catch (e) {
              console.log(url);
            }
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.product.body_html, "text/html");
            const format = doc.querySelector("p").innerText.match(/format:.([\w ]+)/gi);
            if (!format) return resolve(null);
            resolve(format[0].replace(/format:.([\w ]+)/gi, "$1").replace(/dimensions/gi, ""));
          };
          xhr.onerror = resolve.bind(null, null);
          setTimeout(() => xhr.send(), index * 25);
        });
      }
      waitForElement(".product-recommendations--section .productitem--action-trigger", Infinity).then((x) =>
        revampProductTile(x.closest(".product-recommendations--section"))
      );
      waitForElement(".recently-viewed--section .flickity-slider[style]", Infinity).then((x) =>
        revampProductTile(x, true)
      );

      function refreshFlickities() {
        window.dispatchEvent(new Event("resize"));
      }
      if (document.readyState === "complete") refreshFlickities();
      else window.addEventListener("load", refreshFlickities);

      waitForElement(".product-main .product-sku").then((container) => {
        container = container.closest(".product-main");
        const ref = container.querySelector(".product-vendor");
        const authors = [...container.querySelectorAll(".product-vendor > a")].map((x) => x.outerHTML).join(" ");
        const publishers = [...container.querySelectorAll(".product-vendor > span a")]
          .map((x) => x.outerHTML)
          .join(" ");
        const sku = container.querySelector(".product-sku").innerHTML;
        ref.insertAdjacentHTML(
          "beforebegin",
          `<div class="cw-vendor-sku">
            <span class="cw-author">by ${authors}</span>
            <span class="cw-seperator"></span>
            <span class="cw-sku">${sku}</span>
            <span class="cw-publisher">Publisher: ${publishers}</span>
          </div>`
        );
      });

      waitForElement(".product--section .cw-vendor-sku").then((ref) => {
        const jsonScript = document.querySelector('[data-section-type="static-product"]');
        const data = JSON.parse(jsonScript.textContent);
        const body_html = new DOMParser().parseFromString(data.product.description, "text/html");
        const format = body_html
          .querySelector("p")
          .innerText.trim()
          .match(/format:.([\w ]+)/gi);
        if (format) {
          const formatText = format[0].replace(/format:.([\w ]+)/gi, "$1");
          ref.insertAdjacentHTML("afterend", `<div class="cwp-format">${formatText}</div>`);
        }
      });

      waitForElement(".cwp-format").then((ref) => {

        const checkSvg =
          '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0003 13.6L15.9003 7.7C16.0836 7.51667 16.317 7.425 16.6003 7.425C16.8836 7.425 17.117 7.51667 17.3003 7.7C17.4836 7.88334 17.5753 8.11667 17.5753 8.4C17.5753 8.68334 17.4836 8.91667 17.3003 9.1L10.7003 15.7C10.5003 15.9 10.267 16 10.0003 16C9.73363 16 9.50029 15.9 9.30029 15.7L6.70029 13.1C6.51696 12.9167 6.42529 12.6833 6.42529 12.4C6.42529 12.1167 6.51696 11.8833 6.70029 11.7C6.88363 11.5167 7.11696 11.425 7.40029 11.425C7.68363 11.425 7.91696 11.5167 8.10029 11.7L10.0003 13.6Z" fill="#EE304C"/></svg>';
        ref.insertAdjacentHTML(
          "afterend",
          `<div class="cw-usps">
            <div class="cw-usps__item">
              <div class="cw-usps__item--check">${checkSvg}</div>
              <div class="cw-usps__item--text">
                <span style="color: #219653">4.8/5 Trustpilot reviews</span>
                <span>&nbsp;by 1300+ book lovers.</span>
              </div>
            </div>
            <div class="cw-usps__item">
              <div class="cw-usps__item--check">${checkSvg}</div>
              <div class="cw-usps__item--text">
                <span style="font-weight: 700">Most affordable</span>
                <span>&nbsp;price on the market.</span>
              </div>
            </div>
            <div class="cw-usps__item">
              <div class="cw-usps__item--check">${checkSvg}</div>
              <div class="cw-usps__item--text">
                <span style="font-weight: 700">Wide range of books</span>
                <span>&nbsp;available.</span>
              </div>
            </div>
          </div>`
        );
      });

      waitForElement("#product-quantity-select").then((qtyRef) => {
        waitForElement(".product--price .price--main .money").then((priceSaleRef) => {
          const priceRegularRef = document.querySelector(".product--price .price--compare-at .money");
          const moneySaved = document.querySelector(
            ".product-main .product--badge.badge--sale [data-price-money-saved]"
          );
          const percentSaved = document.querySelector(
            ".product-main .product--badge.badge--sale [data-price-percent-saved]"
          );
          const cwQtyPrice = document.createElement("div");
          cwQtyPrice.classList.add("cw-qty-price");
          cwQtyPrice.innerHTML = `<div class="cw-qty-price__qty">
                <button type="button" class="cw-qty-price__qty--down" disabled>&minus;</button>
                <input type="number" class="cw-qty-price__qty--input" value="1" readonly max="9" min="1" />
                <button type="button" class="cw-qty-price__qty--up">&plus;</button>
              </div>
              <div class="cw-qty-price__price">
                <span class="cw-qty-price__price--regular">${
                  priceRegularRef ? priceRegularRef.textContent.trim() : ""
                }</span>
                <span class="cw-qty-price__price--sale">${priceSaleRef.textContent.trim()}</span>
                <span class="cw-qty-price__price--save"${moneySaved && percentSaved ? "" : ' style="display:none;"'}>
                  <span>Save</span>
                  <span data-cw-percentage>${percentSaved ? percentSaved.textContent.trim() : ""}%</span>
                  <span data-cw-amount>(${moneySaved ? moneySaved.textContent.trim() : ""})</span>
                </span>
              </div>`;
          function handleQtyChange(isUp) {
            const input = cwQtyPrice.querySelector(".cw-qty-price__qty--input");
            let value = parseInt(input.value);
            if (isUp) {
              if (value < 9) value++;
            } else {
              if (value > 1) value--;
            }
            input.value = value;
            input.dispatchEvent(new Event("change", { bubbles: true }));
            if (value === 1) cwQtyPrice.querySelector(".cw-qty-price__qty--down").setAttribute("disabled", "");
            else cwQtyPrice.querySelector(".cw-qty-price__qty--down").removeAttribute("disabled");
            if (value === 9) cwQtyPrice.querySelector(".cw-qty-price__qty--up").setAttribute("disabled", "");
            else cwQtyPrice.querySelector(".cw-qty-price__qty--up").removeAttribute("disabled");
          }

          cwQtyPrice.querySelector(".cw-qty-price__qty--down").addEventListener("click", () => {
            handleQtyChange(false);
          });
          cwQtyPrice.querySelector(".cw-qty-price__qty--up").addEventListener("click", () => {
            handleQtyChange(true);
          });
          cwQtyPrice.querySelector(".cw-qty-price__qty--input").addEventListener("change", (e) => {
            qtyRef.value = e.target.value;
            qtyRef.dispatchEvent(new Event("change", { bubbles: true }));
          });

          waitForElement(".cw-usps").then((ref) => ref.after(cwQtyPrice));
        });
      });

      waitForElement("#pi-visa").then(() => {
        const iconIds = [
          "pi-apple_pay",
          "pi-google_pay",
          "pi-master",
          "pi-paypal",
          "pi-visa",
          "pi-american_express",
          "pi-shopify_pay",
        ];
        const icons = iconIds.map((id) => document.getElementById(id).closest("svg").outerHTML);

        function getFormattedEta() {
          const date = new Date();
          let businessDays = 5;
          while (businessDays > 0) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) businessDays--;
          }

          const days = [
            "1st",
            "2nd",
            "3rd",
            "4th",
            "5th",
            "6th",
            "7th",
            "8th",
            "9th",
            "10th",
            "11th",
            "12th",
            "13th",
            "14th",
            "15th",
            "16th",
            "17th",
            "18th",
            "19th",
            "20th",
            "21st",
            "22nd",
            "23rd",
            "24th",
            "25th",
            "26th",
            "27th",
            "28th",
            "29th",
            "30th",
            "31st",
          ];
          const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const dayOfMonth = days[date.getDate() - 1];
          const month = months[date.getMonth()];
          const year = date.getFullYear();
          return `${dayOfMonth} ${month}, ${year}`;
        }

        waitForElement(".product-main .product-description").then((ref) => {
          ref.insertAdjacentHTML(
            "beforebegin",
            `<div class="cw-payment-options">${icons
              .map((x) => {
                return `<div class="cw-payment-options__item">${x}</div>`;
              })
              .join("")}</div>` +
              `<div class="cw-eta">
                <div class="cw-eta__title">Estimated delivery date</div>
                <div class="cw-eta__date">${getFormattedEta()}</div>
              </div>` +
              `` +
              ``
          );
        });
      });

      waitForElement(".product-gallery").then((ref) => {
        ref.insertAdjacentHTML(
          "beforeend",
          ``
        );
      });

      waitForElement(".product-description .is-initialized.is-ready .station-tabs.is-ready").then((tab) => {
        tab.classList.add("mod-full-width", "cw-accordion");
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            observer.disconnect();
            mutation.target.classList.add("mod-full-width", "cw-accordion");
            observer.observe(tab, { attributes: true });
          });
        });
        observer.observe(tab, { attributes: true });
        waitForElement('.station-tabs-content.is-active[id*="st-description"]', Infinity).then(reformatDescription);
      });

      function reformatDescription(content) {

        const refParagraph = content.querySelector("p");
        const hasCondition = refParagraph.innerText.trim().match(/condition:.([\w ]+)/gi);
        const hasFormat = refParagraph.innerText.trim().match(/format:.([\w ]+)/gi);
        if (hasCondition || hasFormat) {
          refParagraph.parentNode.classList.add("cw-condition-format");
          const conditionAndFormat = document.createElement("div");
          conditionAndFormat.classList.add("cw-condition-format__wrapper");
          let html = "";
          if (hasCondition) {
            html += `<div class="cw-condition-format__item">
              <span class="cw-condition-format__item--title">Condition:</span>
              <span class="cw-condition-format__item--value">${hasCondition[0].replace(
                /condition:.(\w+)/gi,
                "$1"
              )}</span>
            </div>`;
          }
          if (hasFormat) {
            html += `<div class="cw-condition-format__item">
              <span class="cw-condition-format__item--title">Format:</span>
              <span class="cw-condition-format__item--value">${hasFormat[0].replace(/format:.(\w+)/gi, "$1")}</span>
            </div>`;
          }
          const ref = content.querySelector("#reviews-widget");
          conditionAndFormat.innerHTML = html;
          ref && ref.before(conditionAndFormat);
          !ref && content.querySelector(".station-tabs-content-inner").appendChild(conditionAndFormat);
        }
      }

      const heartSvg = `<svg width="512" height="512" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none"><path d="M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"></path></svg>`;
      waitForElement(".product-gallery--viewer").then((ref) => {
        ref.insertAdjacentHTML("beforeend", `<button class="cwp-wishlist">${heartSvg}</button>`);
        const newWishlistBtn = ref.querySelector(".cwp-wishlist");
        newWishlistBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          const controlWishlistBtn = document.querySelector(
            ".product-main #wishlisthero-product-page-button-container button"
          );
          if (!controlWishlistBtn.classList.contains("wishlisthero-product-in-wishlist"))
            newWishlistBtn.classList.add("cwp-added");
          if (controlWishlistBtn) controlWishlistBtn.click();
        });

        waitForElement(".wishlisthero-product-in-wishlist")
          .then(() => {
            document.querySelectorAll(".cwp-wishlist").forEach((btn) => btn.classList.add("cwp-added"));
          })
          .catch((e) => true);
      });
    },
  };

  if (window.matchMedia("(min-width: 1024px)").matches) {
    waitForElement(".live-search-form .form-field-input").then((searchInput) => {
      searchInput.placeholder = "Search for a book, or a title...";
    });
  }

  function fixProductGalleryNavOnDesktop() {
    if (!window.matchMedia("(min-width: 1024px)").matches) return;
    const galleryNavItems = document.querySelectorAll(
      ".product-gallery--navigation .gallery-navigation--scroller button"
    );

    const navContainer = document.querySelector(".product-gallery--navigation .gallery-navigation--scroller");
    const navContainerWidth = navContainer.getBoundingClientRect().width + 4;
    const navItemsWidth = [...galleryNavItems].reduce((acc, item) => acc + item.getBoundingClientRect().width, 0);
    if (navItemsWidth > navContainerWidth)
      document.querySelector(".product-gallery--navigation").classList.add("cw-nav-show");
  }
  waitForElement(".product-gallery--navigation .gallery-navigation--scroller button").then(() => {
    if (document.readyState === "complete") fixProductGalleryNavOnDesktop();
    else window.addEventListener("load", fixProductGalleryNavOnDesktop);
  });

  waitForElement("body").then(pdpRevamp.init);
  window.pdpRevamp = pdpRevamp;
})();